import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const rightAlignColumns = css`
    .serviceCol {
      width: 30%;
    }

    .quantityCol,
    .monthlyRevenueCol,
    .monthlyCostCol {
      text-align: right;
    }

    .quantityCol > div,
    .monthlyRevenueCol > div,
    .monthlyCostCol > div {
      justify-content: flex-end !important;
    }

    tbody[data-target=".multi-collapsetotalMrr"] td {
      border-top: 3px solid ${theme.colors.navy["1"]};
    }

    tbody[data-target=".multi-collapsetotalMrr"],
    tbody[data-target=".multi-collapsetcv"],
    tbody[data-target=".multi-collapseprofit"],
    tbody[data-target=".multi-collapsemargin"] {
      background-color: ${theme.colors.white} !important;
      border-top: none !important;
    }

    tbody[data-target=".multi-collapsetotalMrr"] tr {
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapsetcv"] tr {
      padding-top: 4px;
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapseprofit"] tr {
      padding-top: 4px;
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapsemargin"] tr {
      padding-top: 4px;
    }

    tbody[data-target=".multi-collapsetcv"] td,
    tbody[data-target=".multi-collapseprofit"] td,
    tbody[data-target=".multi-collapsemargin"] td {
      border: none;
    }
  `;

  const totalRow = css`
    font-weight: 700;
  `;

  return {
    page,
    rightAlignColumns,
    totalRow,
  };
};

export default useStyles;
